import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useCallback, useEffect, useState } from "react";
import PerfilService from "../../services/PerfilService";
import { useNavigate, useParams } from "react-router-dom";
import AttachmentsPosts from "./AttachmentsPosts";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import FormFieldFileInput from "components/campos/file";
import FormFieldSelect from "components/campos/select";
import canaisService from "../../services/CanaisService";
import PartnershipsService from "../../services/PartnershipsService";
import { toast } from "react-toastify";
import FormFieldSwith from "components/campos/FormFieldSwith";
import * as Yup from 'yup';
import AddressFields from "./AddressFields";
import { get } from "services/post/PartnershipService";

const PartnershipsCreateOrEdit = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [functionPage, setFunctionPage] = useState('create');
  const [user, setUser] = useState({} as any);
  const [loading, setLoading] = useState(false);

  const [subCategoriesBase, setSubCategoriesBase]       = useState([]);
  const [categoriesOptions, setCategoriesOptions]       = useState([]);
  const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
  const [groupCitiesOptions, setGroupCitiesOptions]     = useState([]);

  const [showAddressFields, setShowAddressFields] = useState(true); 

  const [componentKey, setComponentKey] = useState(0);

  const [dados, setDados] = useState(null);
  const [anexos, setAnexos] = useState([]);

  // pegando o parametro da url
  const { id } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    banner: Yup.string().nullable(),
    bannerPreview: Yup.string().nullable(),
    logo: Yup.string().nullable(),
    logoPreview: Yup.string().nullable(),
    partnership: Yup.object().shape({
      category_id: Yup.string().required('Categoria é obrigatória'),
      subcategory_id: Yup.string().required('Subcategoria é obrigatória'),
      name: Yup.string().required('Nome é obrigatório'),
      title: Yup.string().required('Título é obrigatório'),
      description: Yup.string().required('Descrição é obrigatória'),
      about_us: Yup.string().required('Sobre Nós é obrigatório'),
      benefits: Yup.string().required('Benefícios ou como Contribuir é obrigatório'),
      url_video: Yup.string().nullable(),
      url: Yup.string().nullable(),
      email: Yup.string().nullable(),
      phone: Yup.string().nullable(),
      instagram: Yup.string().nullable(),
      linkedin: Yup.string().nullable(),
      facebook: Yup.string().nullable(),
      youtube: Yup.string().nullable(),
      tiktok: Yup.string().nullable(),
      hasnt_address: Yup.boolean().nullable(),
    }),
    // address: Yup.object().when('tip.hasnt_address', {
    //   is: false, // Valida o endereço apenas se hasnt_address for false
    //   then: Yup.object().shape({
    //     country: Yup.string().required('País é obrigatório'),
    //     state: Yup.string().required('Estado é obrigatório'),
    //     city: Yup.string().required('Cidade é obrigatória'),
    //     postal_code: Yup.string().required('CEP é obrigatório'),
    //     address: Yup.string().required('Endereço é obrigatório'),
    //     number: Yup.string().required('Número é obrigatório'),
    //     district: Yup.string().required('Bairro é obrigatório'),
    //     complement: Yup.string().nullable(),
    //   }),
    //   otherwise: Yup.object().strip(), // Remove o objeto address se hasnt_address for true
    // }),
    post: Yup.object().shape({
      group_city_id: Yup.string().required('Grupo de cidades é obrigatório'),
    }),
  });

  const setNestedValue = (object: any, path: string, value: any) => {
    const keys = path.split(".");
    const lastKey: any = keys.pop();
    const lastObj = keys.reduce((obj, key) => {
      if (!obj[key]) obj[key] = {};
      return obj[key];
    }, object);
    lastObj[lastKey] = value;
  };
  
  const useForm = (initialState: any) => {
    const [formData, setFormData] = useState(initialState);
  
    const handleChange = (fieldName: string, value: any) => {
      setFormData((prevData: any) => {
        const newData = { ...prevData };
        setNestedValue(newData, fieldName, value);
    
        // Atualiza a visibilidade dos campos de endereço
        if (fieldName === "partnership.hasnt_address") {
          setShowAddressFields(!value); // Inverte o valor (true/false)
        }
    
        return newData;
      });
    };
  
    return { formData, handleChange };
  };

  const { formData, handleChange } = useForm({
    banner: "",
    bannerPreview: "",
    logo: "",
    logoPreview: "",
    partnership: {
      category_id: "",
      subcategory_id: "",
      name: "",
      title: "",
      description: "",
      about_us: "",
      benefits: "",
      // is_social: "",
      url_video: "",
      url: "",
      email: "",
      phone: "",
      instagram: "",
      linkedin: "",
      facebook: "",
      youtube: "",
      tiktok: "",
      hasnt_address: false,
    },
    address: {
      country: "",
      state: "",
      city: "",
      postal_code: "",
      address: "",
      number: "",
      district: "",
      complement: "",
    },
    post: {
      group_city_id: "",
    },
  });

  useEffect(() => {
    if (id) {
      setFunctionPage('edit');
    }
  }, [id]);

  useEffect(() => {
    if (dados) {

      handleChange("partnership.category_id", dados?.category_id);
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == dados?.category_id));      

      handleChange("partnership.category_id", dados?.category_id);
      handleChange("partnership.subcategory_id", dados?.subcategory_id);
      handleChange("partnership.name", dados?.name);
      handleChange("partnership.title", dados?.title);
      handleChange("partnership.description", dados?.description);
      handleChange("partnership.about_us", dados?.about_us);
      handleChange("partnership.benefits", dados?.benefits);
      handleChange("partnership.url_video", dados?.url_video);
      handleChange("partnership.url", dados?.url);
      handleChange("partnership.email", dados?.email);
      handleChange("partnership.phone", dados?.phone);
      handleChange("partnership.instagram", dados?.instagram);
      handleChange("partnership.linkedin", dados?.linkedin);
      handleChange("partnership.facebook", dados?.facebook);
      handleChange("partnership.youtube", dados?.youtube);
      handleChange("partnership.tiktok", dados?.tiktok);
      handleChange("partnership.hasnt_address", dados?.hasnt_address);
      handleChange("bannerPreview", dados?.banner_path);
      handleChange("logoPreview", dados?.logo_path);
  
      if (dados?.address) {
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);
      }
  
      handleChange("post.group_city_id", dados?.post?.group_city_id);

      setAnexos(dados.attachments);

      // 🔹 Atualiza a key para forçar re-renderização
      setComponentKey((prevKey) => prevKey + 1);
    }
  }, [dados]);

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        await getUser();
        await getCanais(5);
        if (id) {
          await getPartnership(id);
        }
      }
      fetchData();
    }, []);  

  const getPartnership = async (tipId : any) => {

    await get(tipId)
      .then((response: any) => {
        setDados(response.data);

        if(response.data.address == null){
          handleChange("partnership.hasnt_address", true);
          setShowAddressFields(false);
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  const getUser = async () => {
    await PerfilService.getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
       //setLoading(false); // end loading
      });
  };

  const getCanais = async (idTipo: any) => {
    await canaisService
      .getCanais(idTipo, "")
      .then((response: any) => {

        const categories = response.categories.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        const subcategories = response.subcategories.map((item: any) => {
          return { value: item.id, label: item.name, category_id: item.category_id };
        });

        const groupCities = response.group_cities.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        groupCities.sort((a: any, b: any) => a.label.localeCompare(b.label));

        setCategoriesOptions(categories);
        setGroupCitiesOptions(groupCities);
        setSubCategoriesOptions(subcategories);

        setSubCategoriesBase(subcategories);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const submit = async () => {

    try {
      // Valida o formulário
      await validationSchema.validate(formData, { abortEarly: false });

      if (functionPage == 'create') {
        // Valida se o banner foi enviado
        if (!formData.banner) {
          toast.error('Banner é obrigatório');
          setErrors({ ...errors, banner: 'Banner é obrigatório' });
          return;
        }

        // Valida se a logo foi enviada
        if (!formData.logo) {
          toast.error('Logo é obrigatória');
          setErrors({ ...errors, logo: 'Logo é obrigatória' });
          return;
        }
      }

      // Verificando manualmente se os campos de endereço são obrigatórios - se hasnt_address for false pais e estado somente
      if (!formData.partnership.hasnt_address) {
        if (!formData.address.country) {
          toast.error('País é obrigatório');
          setErrors({ ...errors, 'address.country': 'País é obrigatório caso declare endereço' });
          return;
        }
        if (!formData.address.state) {
          toast.error('Estado é obrigatório');
          setErrors({ ...errors, 'address.state': 'Estado é obrigatório caso declare endereço' });
          return;
        }
      }

      // Se a validação passar, prossegue com o envio
      let newDados: any = {
        partnership: {
          category_id: formData.partnership.category_id,
          subcategory_id: formData.partnership.subcategory_id,
          name: formData.partnership.name,
          title: formData.partnership.title,
          description: formData.partnership.description,
          about_us: formData.partnership.about_us,
          benefits: formData.partnership.benefits,
          is_social: 0, // deixando default como parceiro comum
          url_video: formData.partnership.url_video,
          url: formData.partnership.url,
          email: formData.partnership.email,
          phone: formData.partnership.phone,
          instagram: formData.partnership.instagram,
          linkedin: formData.partnership.linkedin,
          facebook: formData.partnership.facebook,
          youtube: formData.partnership.youtube,
          tiktok: formData.partnership.tiktok,
          hasnt_address: formData.partnership.hasnt_address,
          banner: formData.banner,
          logo: formData.logo,
        },
        post: {
          group_city_id: formData.post.group_city_id,
        },
      };
  
      if (!formData.partnership.hasnt_address) {
        newDados.address = {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        };
      }
  
      newDados = verificarBannerDica(newDados);
      newDados = verificaLogoDica(newDados);
    
      let response: any;
      if (id) {
        response = await PartnershipsService.update(id, newDados);
      } else {
        response = await PartnershipsService.post(newDados);
      }
  
      toast.success('Parceria salva com sucesso!');
      navigate('/minhas-parcerias');

    } catch (error : any) {

      if (error instanceof Yup.ValidationError) {
        // Exibe os erros de validação
        const errors = error.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {} as Record<string, string>);
  
        console.log('errors setando', errors);
        setErrors(errors);

        // Exibe o primeiro erro encontrado
        const firstError = Object.values(errors)[0];
        toast.error(firstError);

      } else {
       //informa o primeiro erro retornado considerando que o backend é em laravel com um arquivo de request
       toast.error(error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]);
      }
    }
  };

  const verificarBannerDica = (obj: any) => {
    if (obj.partnership.banner == "") {
      obj.partnership.banner_path = dados.banner_path;
    }

    return obj;
  };

  const verificaLogoDica = (obj: any) => {
    if (obj.partnership.logo == "") {
      obj.partnership.logo_path = dados.logo_path;
    }

    return obj;
  }

  const handleCategoryChange = useCallback((categoryId: any) => {
    if (categoryId) {
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == categoryId)); 
    } else {
      setSubCategoriesOptions([]);
    }
    handleChange("partnership.subcategory_id", "");
  }, [subCategoriesBase]);

  return (
    <Layout user={user}>
      <LayoutDashboard>
      <>
        <div className="flex-end">
          <ButtonPrimary
            className="md:col-span-2"
            type="button"
            onClick={() => navigate('/minhas-parcerias')}
          >
            Voltar
          </ButtonPrimary>
        </div>
        <br />

        {
          loading ? (
            <div>
              <div className="spinner border-primary-600 my-20"></div>
            </div>
          ) : (
            <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
              {dados != null && <AttachmentsPosts tipoTela={3} dados={dados} anexos={anexos} setAnexos={setAnexos} />}
    
              <form className="grid md:grid-cols-2 gap-6" action="#" method="post">
    
                <FormFieldSelect
                  key={'category_id_' + componentKey}
                  label={'Categoria'}
                  fieldName={'partnership.category_id'}
                  options={categoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  action={handleCategoryChange}
                  error={errors['partnership.category_id']}
                />
    
                <FormFieldSelect
                  key={'subcategory_id'}
                  label={'Subcategoria'}
                  fieldName={'partnership.subcategory_id'}
                  options={subCategoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.subcategory_id']}
                />
    
                <FormFieldInput
                  key={"name"}
                  label={"Nome"}
                  fieldName={"partnership.name"}
                  type={"text"}
                  extraProps={{ mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['partnership.name']}
                />
    
                <FormFieldInput
                  key={"title"}
                  label={"Título"}
                  fieldName={"partnership.title"}
                  type={"text"}
                  extraProps={{ mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['partnership.title']}
                />
    
                <FormFieldTextArea
                  key={"description"}
                  label={"Descrição"}
                  fieldName={"partnership.description"}
                  extraProps={{ rows: 8, mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.description']}
                />
    
                <FormFieldTextArea
                  key={"about_us"}
                  label={"Sobre Nós"}
                  fieldName={"partnership.about_us"}
                  extraProps={{ rows: 8, mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.about_us']}
                />

                <FormFieldTextArea
                  key={"benefits"}
                  label={"Benefícios ou como Contribuir"}
                  fieldName={"partnership.benefits"}
                  extraProps={{ rows: 8, mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.benefits']}
                />

                {/* <FormFieldSelect
                  key={"is_social"}
                  label={"É Radar Social?"}
                  fieldName={"partnership.is_social"}
                  options={[
                    { value: 1, label: "Sim" },
                    { value: 0, label: "Não" },
                  ]}
                  formData={formData}
                  handleChange={handleChange}
                  // extraProps={{ mdColSpan: 2 }}
                  // classe={"md:col-span-2"}
                  error={errors['post.is_social']}
                /> */}

                <FormFieldSelect
                  key={"group_city_id"}
                  label={"Grupo de Cidades"}
                  fieldName={"post.group_city_id"}
                  options={groupCitiesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  // extraProps={{ mdColSpan: 2 }}
                  // classe={"md:col-span-2"}
                  error={errors['post.group_city_id']}
                />

                <FormFieldInput
                  key={"url_video"}
                  label={"URL EMBED do Vídeo"}
                  fieldName={"partnership.url_video"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.url_video']}
                />
    
                <FormFieldInput
                  key={"url"}
                  label={"Link"}
                  fieldName={"partnership.url"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.url']}
                />

                <FormFieldInput
                  key={"email"}
                  label={"Email"}
                  fieldName={"partnership.email"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.email']}
                />
    
                <FormFieldInput
                  key={"phone"}
                  label={"Telefone"}
                  fieldName={"partnership.phone"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.phone']}
                />

                <FormFieldInput
                  key={"instagram"}
                  label={"Instagram"}
                  fieldName={"partnership.instagram"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.instagram']}
                />

                <FormFieldInput
                  key={"linkedin"}
                  label={"Linkedin"}
                  fieldName={"partnership.linkedin"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.linkedin']}
                />

                <FormFieldInput
                  key={"facebook"}
                  label={"Facebook"}
                  fieldName={"partnership.facebook"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.facebook']}
                />

                <FormFieldInput
                  key={"youtube"}
                  label={"Youtube"}
                  fieldName={"partnership.youtube"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.youtube']}
                />

                <FormFieldInput
                  key={"tiktok"}
                  label={"Tiktok"}
                  fieldName={"partnership.tiktok"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['partnership.tiktok']}
                />
    
                <hr className="mt-5 col-span-1 md:col-span-2" />
    
                <FormFieldSwith 
                  label={"Essa dica não possui endereço ?"} 
                  fieldName={"partnership.hasnt_address"} 
                  formData={formData} 
                  handleChange={handleChange} 
                  extraProps={{ mdColSpan: 2 }} 
                  classe={"md:col-span-2"}
                  error={errors['partnership.hasnt_address']}
                />
                
                <div
                  className={`col-span-1 md:col-span-2 transition-all duration-300 ease-in-out ${
                    showAddressFields
                      ? "opacity-100 max-h-[1000px] overflow-visible"
                      : "opacity-0 max-h-0 overflow-hidden"
                  }`}
                >
                  <AddressFields formData={formData} handleChange={handleChange} errors={errors} />
                </div>
    
                <FormFieldFileInput
                  key={"banner"}
                  label={"Banner"}
                  fieldName={"banner"}
                  formData={formData}
                  handleChange={handleChange}
                  classNameImagem={""}
                  tipo={3}
                  error={errors['banner']}
                />

                <FormFieldFileInput
                  key={"logo"}
                  label={"Logo"}
                  fieldName={"logo"}
                  formData={formData}
                  handleChange={handleChange}
                  classNameImagem={""}
                  tipo={3}
                  error={errors['logo']}
                />
    
                <ButtonPrimary
                  className="md:col-span-2"
                  type="button"
                  onClick={submit}
                >
                  {functionPage == 'create' ? 'Salvar' : 'Editar'}
                </ButtonPrimary>
              </form>
            </div>
          )
        }

      </>
      </LayoutDashboard>
    </Layout>
  );
};

export default PartnershipsCreateOrEdit;
